import React from 'react'
import { I18n } from 'react-redux-i18n'

import { getStaticImage } from 'utils/statics'
import WrapperImg from './WrapperImg'

const DEFAULT_AVATAR = getStaticImage('/icons/orange-brand/icon-avatar.svg')

/**
 * Avatar image
 * @param {object} props
 * @param {string} props.src
 * @param {string} [props.alt]
 * @param {string} [props.title]
 * @param {string} [props.className]
 */
const AvatarImg = (props) => {
  const { src, title = '', alt = '', className = '' } = props

  return (
    <WrapperImg
      src={src}
      title={title}
      className={className}
      alt={alt || I18n.t('avatar_profile_image')}
      defaultSrc={DEFAULT_AVATAR}
    />
  )
}

export default AvatarImg